import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { Provider } from '@angular/core';

/**
 * CDK 21 renders dialogs in the browser top layer, above any z-index. Keeping
 * them in the overlay container lets the loading overlay and toasts (appended
 * to `<body>`) stack above open modals.
 */
export function provideOverlayStacking(): Provider {
  return { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } };
}
